class EstimateDeliveryDate extends HTMLElement {
    country = false;
    isDebug = false;

    constructor() {
        super();

        this.geoIpCacheTTL = 4 * 60 * 60 * 1000; // 4 hours
        this.geoIpCacheKey = 'visitor_country_cache';
        this.renderEstimatedDelivery();
    }


    log(message, data = null) {
        if (!this.isDebug) return;
        console.log(`[EstimateDeliveryDate] ${message}`, data || '');
    }

    fetchGeo() {
        this.log('Fetching GeoIP...');
        fetch("https://ipapi.co/json/")
            .then(res => res.json())
            .then(data => {
                if (data && data.country) {
                    const cacheData = {
                        country: data.country,
                        timestamp: Date.now()
                    };
                    window.localStorage.setItem(this.geoIpCacheKey, JSON.stringify(cacheData));
                    this.countryCode = data.country || 'US'; // Default to US if no country found
                    this.log('GeoIP fetched and cached:', cacheData);
                }
            })
            .catch(error => {
                this.log('GeoIP fetch failed:', error);
            });
    }

    getCountry() {
        if (this.countryCode) {
            return this.countryCode;
        }
        const cache = window.localStorage.getItem(this.geoIpCacheKey);
        if (cache) {
            try {
                const parsedCache = JSON.parse(cache);
                const now = Date.now();
                if ((now - parsedCache.timestamp) > this.geoIpCacheTTL) {
                    this.fetchGeo();
                }
                this.countryCode = parsedCache.country || 'US'; // Default to US if no country found
            } catch (e) {
                this.log('Error parsing GeoIP cache, refetching.', e);
                this.fetchGeo();
            }
        } else {
            this.log('No cached GeoIP found, fetching...');
            this.fetchGeo();
        }
        return this.countryCode; // Default to US if no country found
    }
    getDeliveryEstimateDate(countryCode) {
        const now = new Date();
        const hour = now.getHours();
        const day = now.getDay(); // 0 = Sunday, 6 = Saturday

        let addDays = 0;

        // Delivery windows
        if (['FR', 'MC'].includes(countryCode)) {
            addDays = 2;
        } else if (['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'GB'].includes(countryCode)) {
            addDays = 4;
        } else if (['US', 'CA'].includes(countryCode)) {
            addDays = 5;
        } else {
            addDays = 6;
        }

        now.setDate(now.getDate() + addDays);
        const locale = window.Shopify?.locale || 'en';
        return now.toLocaleDateString(locale, { weekday: 'long', month: 'long', day: 'numeric' }).replace(/^./, str => str.toUpperCase());
    }

    renderEstimatedDelivery() {
        const el = this.querySelector('span');
        if (!el) return;

        el.innerText = '';

        try {
            const estimate = this.getDeliveryEstimateDate(this.getCountry());
            el.innerText = estimate;
            this.classList.remove('shimmer');
        } catch (err) {
            console.error('Error parsing country cache', err);
        }
    }
}

window.customElements.define("estimate-delivery-date", EstimateDeliveryDate);